module.exports = __webpack_public_path__ + "static/media/taqunsenation.ddee013f.png";